export {};
//# sourceMappingURL=aliases.js.map